import { UserRole } from '@e2m-customer-portal/shared';
import jwtDecode from 'jwt-decode';

interface TokenInfoSource {
  contract_ids?: readonly string[];
  roles?: readonly UserRole[];
  email: string;
}

export interface TokenInfo {
  contractIds: ReadonlySet<string>;
  roles: ReadonlySet<UserRole>;
  email?: string;
}

export function useTokenInfo(): Readonly<TokenInfo> {
  const tokenString = localStorage.getItem('token');
  if (!tokenString) {
    return {
      contractIds: new Set(),
      roles: new Set(),
    };
  }
  const token = jwtDecode<TokenInfoSource>(tokenString);
  return {
    contractIds: new Set(token.contract_ids ?? []),
    roles: new Set(token.roles ?? []),
    email: token.email,
  };
}
